import React from "react";
import { Studies } from "../../constant";
import {Col, Row} from 'react-bootstrap'

const Formation = ({date, title, location, place}) => {
    return <div className='cv__formation mb-3'>
        <Row>
            <Col md={3}>
                <span>{date}</span><br />{place}
            </Col>
            <Col md={9}>
                {title} <br /> <span>{location}</span>
            </Col>
        </Row>
    </div>
}

const Formations = () => {
   
    return (
        <div className="cv__formations">
            <h2>Formation</h2>
            {
                Studies.map((v, k) => {
                    return <Formation key={k} {...v} />
                })
            }
        </div>
    )
}

export default Formations